import { getRequest, postFormData } from '.'

export const getGlobalNewsItems = async (): Promise<
  wowaudit.GlobalNewsItem[]
> => {
  return await getRequest('/api/global_news_items')
}

export const getGlobalNewsItem = async (
  id: number,
): Promise<wowaudit.GlobalNewsItem> => {
  return await getRequest(`/api/global_news_items/${id}`)
}

export const uploadGlobalNewsFile = async (
  file: File,
): Promise<{ url: string }> => {
  const formData = new FormData()
  formData.append('file', file)
  return await postFormData('/api/files', formData)
}
